import React, { useState } from 'react'

import {
  Form,
  Input,
  Checkbox,
  Button,
  Row,
  Col,
  Tooltip,
  Typography,
  Modal,
} from 'antd'

const { Title, Paragraph, Text } = Typography

import {
  InfoCircleOutlined,
  LeftCircleFilled,
  RightCircleFilled,
} from '@ant-design/icons'
import Icon, { CheckOutlined } from '@ant-design/icons'

import { Page } from '@/structure'
import { Stepper, Tile, AutoSearch } from '@/components'
import { FormItemPasswordProgress } from '@/components/Login/'
import { Img } from '../components/common'

const Elements = () => {
  const { info } = Modal

  function showModal() {
    info({
      icon: <InfoCircleOutlined />,
      closable: true,
      content: (
        <>
          <Title level={3}>Erlaubte Dateitypen für den Dokument-Upload</Title>
          <Paragraph className="paragraph-s">
            Laden Sie Ihre Originaldatei im Microsoft Word- / LibreOffice- /
            RTF-Format hoch. PDF-Dateien akzeptieren wir ebenfalls, diese können
            aber unter Umständen nicht für alle Vertriebskanäle (z.B. Kindle,
            iBookstore) konvertiert werden.
          </Paragraph>
        </>
      ),
      footer: null,
    })
  }

  return (
    <Page className="styleguide">
      <Title>Styleguide</Title>
      <Title level={3}>Input fields</Title>
      <br />
      <Row>
        <Form layout="vertical">
          <Col span={11}>
            <Form.Item label="First Name *">
              <Input placeholder="Your First Name" />
            </Form.Item>
            <Form.Item label="E-Mail *">
              <Input placeholder="ms@grin.com" />
            </Form.Item>
            <Form.Item label="Subject">
              <Input
                placeholder="Physics"
                suffix={
                  <Tooltip title="Extra information">
                    <InfoCircleOutlined style={{ color: '#3DAA35' }} />
                  </Tooltip>
                }
              />
            </Form.Item>
            <Form.Item
              label="E-Mail *"
              validateStatus="error"
              hasFeedback
              help="Please enter valid email address"
            >
              <Input defaultValue="1234r" />
            </Form.Item>
            <br />
            <br />
            <FormItemPasswordProgress />
            <br />
            <br />
            <Title level={3}>Checkbox</Title>
            <br />
            <Form.Item label="">
              <Checkbox>
                Mit der Registrierung stimmst Du unseren
                Datenschutzbestimmun-gen und unseren AGB zu. Falls Du unter 18
                Jahre alt bist, versicherst Du, dass deine
                Erziehungsberechtigten unseren Datenschutzbestimmun-gen und AGB
                zustimmen.
              </Checkbox>
            </Form.Item>
            <br />
            <Form.Item>
              <Checkbox checked="checked"></Checkbox>
            </Form.Item>
            <br />
            <br />
          </Col>
          <Title level={3}>Buttons</Title>
          <br />
          <Row justify="space-between">
            <Col span="6">
              <Form.Item>
                <Button type="primary" block>
                  LOGIN
                </Button>
              </Form.Item>
              <Form.Item>
                <Button type="primary" block>
                  LOGIN
                </Button>
              </Form.Item>
              <Form.Item>
                <Button type="primary" block disabled>
                  LOGIN
                </Button>
              </Form.Item>
            </Col>
            <Col span="13">
              <LeftCircleFilled
                className="pager"
                style={{ color: '#3589AA', paddingRight: '20px' }}
              />
              <RightCircleFilled
                className="pager"
                style={{ color: '#3589AA' }}
              />
              <br />
              <br />
              <LeftCircleFilled
                className="pager"
                style={{ color: '#2A6D88', paddingRight: '20px' }}
              />
              <RightCircleFilled
                className="pager"
                style={{ color: '#2A6D88' }}
              />
              <br />
              <br />
              <LeftCircleFilled
                className="pager"
                style={{ color: '#1F5266', paddingRight: '20px' }}
              />
              <RightCircleFilled
                className="pager"
                style={{ color: '#1F5266' }}
              />
            </Col>
          </Row>
        </Form>
      </Row>
      <br />
      <br />
      <Title level={3}>Stepper - Desktop</Title>
      <Row>
        <Col span="20">
          <Stepper currentStep={0} />
        </Col>
      </Row>
      <Row>
        <Col
          className="test-mobile"
          span="8"
          style={{ padding: '30px 0 50px' }}
        >
          <Stepper currentStep={0} />
        </Col>
      </Row>
      <Title level={3}>Tile</Title>
      <Row style={{ flexFlow: 'nowrap' }} gutter={48}>
        <Col>
          <Tile title="einmalhonorar">
            <Title level={3}>
              Erhalten Sie eine einmalige Auszahlung von 10€.
            </Title>
            <Img
              className="tile-icon"
              src={'images/contract/license.webp'}
              style={{ paddingBottom: '8px' }}
            />
            <div>
              Damit <b>garantieren wir Ihnen einen einmaligen Erlös</b> nach
              Veröffentlichung Ihres Textes, unabhängig von den <br />
              Verkaufszahlen.
            </div>
            <Button block>WAHLEN</Button>
          </Tile>
        </Col>
        <Col>
          <Tile title="einmalhonorar">
            <Title level={3}>
              Erhalten Sie eine einmalige Auszahlung von 10€.
            </Title>
            <Img
              className="tile-icon"
              src={'images/contract/license.webp'}
              style={{ paddingBottom: '8px' }}
            />
            <div>
              Damit <b>garantieren wir Ihnen einen einmaligen Erlös</b> nach
              Veröffentlichung Ihres Textes, unabhängig von den <br />
              Verkaufszahlen.
            </div>
            <Button block>WAHLEN</Button>
          </Tile>
        </Col>
        <Col>
          <Tile title="autorenhonorar" className="contract" selected>
            <Title level={3}>
              Verdienen Sie
              <br /> mit jedem Verkauf.
            </Title>
            <img
              className="contract-img"
              src="images/contract/free_ebook.svg"
            />
            <div>
              Wir bieten Ihren Text weltweit in den größten Online-Shops und
              Buchhandlungen an. Bei jedem Verkauf erhalten Sie ein faires{' '}
              <b>Autorenhonorar von bis zu 35 %.</b>
            </div>
            <Button type="primary" block>
              OPTION GEWAHLT
              <CheckOutlined />
            </Button>
          </Tile>
        </Col>
      </Row>
      <br />
      <br />
      <Title level={3}>Tooltip</Title>
      <Row justify="center">
        <Col span="8">
          <Tooltip
            placement="left"
            title="Ihr Werk befindet sich in der Bearbeitung zur Veröffentlichung."
          >
            <img src="images/contract/success.svg" />
          </Tooltip>
        </Col>
      </Row>
      <Title level={3}>Layer</Title>
      <br />
      <Row>
        <Button type="primary" onClick={showModal}>
          Open Info
        </Button>
      </Row>
      <br />
      <Title level={3}>Search</Title>
      <Row>
        <AutoSearch />
      </Row>
      <br />
      <br />
      <br />
      <Title level={3}>Fonts//sizes</Title>
      <br />
      <Row>
        <br />
        <Col>
          <Title>h1. Headline (28/36)</Title>
          <Title level={2}>h2. Headline (22/34)</Title>
          <Title level={3}>h3. Sub-headline (20/26)</Title>
          <Paragraph>Paragraph L (18/26)</Paragraph>
          <Paragraph className="paragraph-s">Paragraph S (16/24)</Paragraph>
          <Paragraph className="paragraph-sb">
            Paragraph S (SemiBold) (16/24)
          </Paragraph>
          <Title level={5}>Option Headline</Title>
          <Text className="caption">Caption xs (Reg)</Text>
          <br />
          <Text className="caption-sb">Caption xs (SemiBold)</Text>
        </Col>
      </Row>
      <br />
    </Page>
  )
}

export default Elements
